import {Component, Input} from '@angular/core';
import {Step} from './step';

@Component({
  selector: 'stepper',
  template: require('./stepper.component.html')
})
export class StepperComponent {
  @Input() transactionSteps: Step[];
  constructor() {}

isCurrentStep(index: number) {
		return (
			(index + 1 === this.transactionSteps.length || !this.transactionSteps[index + 1].isActive) &&
			this.transactionSteps[index].isActive
		);
	}
}
